import { createContext, type Dispatch } from 'react';
import { INIT_LOADING_STATE } from './reducer';
import type { LoadingQueryKey } from './types';

type LoadingMapAction = {
  type: 'UPDATE_LOADING_STATE';
  payload: { key: LoadingQueryKey; value: boolean };
};

type LoadingMapContextType = {
  loadingMapState: Record<LoadingQueryKey, boolean>;
  reducerDispatch: Dispatch<LoadingMapAction>;
  loadingByComponent: Record<string, boolean>;
};

export const LoadingMapContext = createContext<LoadingMapContextType>({
  loadingMapState: INIT_LOADING_STATE,
  reducerDispatch: () => {},
  loadingByComponent: {},
});
